import { GlobalOrderItemUi } from '@/components/Order/GlobalOrders/GlobalOrdersUi';
import { GlobalOrderResponse } from '@/data/api/model/orders/globalOrdersDto';
import { formatDollarAmount } from '@/utils/amounts';
import { formatDate } from '@/utils/dateTime';

export function globalOrderResponseToGlobalOrderItemUi(
  order: GlobalOrderResponse
): GlobalOrderItemUi {
  return {
    id: order.order_id,
    orderNumber: order.order_number.toString(),
    totalOrderAmount: formatDollarAmount(Number(order.total_order_amount)),
    createdAt: formatDate(order.created_at, { time: true }),
    buyerBusinessName: order.buyer_business_name,
    adminName: order.admin_name,
    paymentMethod: order.payment_method,
  };
}
